import { useState, useEffect, Suspense } from 'react';
import "@/App.css";

// Context
import { WishlistProvider } from './context/WishlistContext';

// Components
import Navigation from './components/custom/Navigation';
import Hero3D from './components/custom/Hero3D';
import GallerySection from './components/custom/GallerySection';
import ArtworkDetailModal from './components/custom/ArtworkDetailModal';
import AboutSection from './components/custom/AboutSection';
import WhyChooseSection from './components/custom/WhyChooseSection';
import TestimonialsSection from './components/custom/TestimonialsSection';
import ContactSection from './components/custom/ContactSection';
import WhatsAppFloat from './components/custom/WhatsAppFloat';
import Footer from './components/custom/Footer';
import WishlistDrawer from './components/custom/WishlistDrawer';

// Loading Screen
const LoadingScreen = () => (
  <div className="loading-overlay" data-testid="loading-screen">
    <div className="text-center">
      <div className="loading-spinner mb-4" />
      <p className="font-cinzel text-[#D4AF37] text-lg">Ethereal Calligraphy</p>
      <p className="font-manrope text-gray-500 text-sm mt-2">Loading Experience...</p>
    </div>
  </div>
);

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedArtwork, setSelectedArtwork] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Simulate initial loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleSelectArtwork = (artwork) => {
    setSelectedArtwork(artwork);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = 'unset';
    setTimeout(() => setSelectedArtwork(null), 300);
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <WishlistProvider>
      <div className="app-container" data-testid="app-container">
        {/* Navigation */}
        <Navigation />

        {/* Main Content */}
        <main>
          {/* Hero Section with 3D */}
          <Suspense fallback={<LoadingScreen />}>
            <Hero3D />
          </Suspense>

          {/* Section Divider */}
          <div className="section-divider" />

          {/* Gallery Section */}
          <GallerySection onSelectArtwork={handleSelectArtwork} />

          {/* Section Divider */}
          <div className="section-divider" />

          {/* About Section */}
          <AboutSection />

          {/* Section Divider */}
          <div className="section-divider" />

          {/* Why Choose Us */}
          <WhyChooseSection />

          {/* Section Divider */}
          <div className="section-divider" />

          {/* Testimonials */}
          <TestimonialsSection />

          {/* Section Divider */}
          <div className="section-divider" />

          {/* Contact Section */}
          <ContactSection />
        </main>

        {/* Footer */}
        <Footer />

        {/* Floating WhatsApp Button */}
        <WhatsAppFloat />

        {/* Wishlist Drawer */}
        <WishlistDrawer onSelectArtwork={handleSelectArtwork} />

        {/* Artwork Detail Modal */}
        <ArtworkDetailModal
          artwork={selectedArtwork}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      </div>
    </WishlistProvider>
  );
}

export default App;
